import { useTheme } from "styled-components";

import { ColumnContainer, RowContainer } from "@sso/ui/FlexBox";
import { RawCheckbox } from "@sso/ui/RawCheckbox";
import { Typography } from "@sso/ui/Typography";

interface CheckboxProps {
  id?: string;
  label?: string;
  error?: boolean;
  disabled?: boolean;
  errorText?: string | null;
}

export const Checkbox = ({ id, label, error, disabled, errorText, ...rest }: CheckboxProps) => {
  const theme = useTheme();
  return (
    <ColumnContainer align="flex-start">
      <RowContainer>
        <RawCheckbox id={id} error={error} disabled={disabled} {...rest} />
        {label && (
          <label htmlFor={id}>
            <Typography>{label}</Typography>
          </label>
        )}
      </RowContainer>
      {error && (
        <Typography color={theme.colors.error.main} size="0.8rem" textAlign="left" margin="0.2rem 0.5rem">
          {errorText}
        </Typography>
      )}
    </ColumnContainer>
  );
};
